import { render, staticRenderFns } from "./Aneel1.vue?vue&type=template&id=7356c5ca&"
import script from "./Aneel1.vue?vue&type=script&lang=js&"
export * from "./Aneel1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports